export default __webpack_public_path__ + "static/media/image-gallery-svgrepo-com.ab911cb2.svg";